import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { audience } from '../../data/content';

/** Section 7 — who it is for. */
export function AudienceSection() {
  return <section aria-labelledby="audience-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-30" data-mp="1y9ennbinic8p">
      <div className="mx-auto max-w-5xl" data-id="element-31" data-mp="1t7z3dloas9rd">
        <SectionHeading id="audience-heading" title={<>
              Créé pour les professionnelles <Accent data-id="element-33" data-mp="238hv12m3suju">qui enseignent le maquillage.</Accent>
            </>} data-id="element-32" data-mp="286t3b8wr2wzy" />

        <ul className="mt-12 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3" role="list" data-id="element-34" data-mp="2gzmplqam6wnb">
          {audience.map(item => <li key={item} className="flex items-center gap-3 rounded-[16px] border border-brand-charcoal/10 bg-white px-4 py-4 text-[15px] font-medium leading-snug text-brand-charcoal" data-id="element-35" data-mp="2cy1f2bljyuga">
              <span className="flex h-7 w-7 flex-none items-center justify-center rounded-full bg-brand-lavender" data-id="element-36" data-mp="2lwd0lz7kb21v">
                <CheckIcon className="h-4 w-4 text-brand-plum" strokeWidth={2.5} aria-hidden="true" data-id="element-37" data-mp="1xanko02b4f9c" />
              </span>
              {item}
            </li>)}
        </ul>

        <p className="mx-auto mt-12 max-w-3xl text-center font-display text-[1.7rem] font-bold leading-snug text-brand-charcoal sm:text-[2rem]" data-id="element-38" data-mp="22c4mbxsm85qz">
          Vous connaissez déjà le maquillage.
          <span className="block" data-id="element-39" data-mp="2b8c91hvl24j5">
            Maintenant, <Accent data-id="element-40" data-mp="2g8rk22se6zxy">simplifiez la façon dont vous l’enseignez.</Accent>
          </span>
        </p>
      </div>
    </section>;
}